import { useCallback, useState } from 'react';
import _get from 'lodash/get';
import { Documentation } from 'graphql-common';
import TaskCompletionForm from 'components/TaskCompletionForm/TaskCompletionForm';
import { DocumentReadRecord } from 'components/TaskCompletionForm/DocumentQuestionField';
import getValues from 'routes/Task/utils/getValues';
import useFields from './utils/useFields';
import useActions from './utils/useActions';

function TaskCompletionViewContainer() {
  const {
    id = '',
    isViewLocked,
    taskDataForCompletion,
    taskFormTemplateVersion,
    taskCompletionError,
    taskCompletionLoading = false,
    formRef,
  } = useActions();
  const questions = _get(taskFormTemplateVersion, 'questions', []);
  const answers = _get(taskDataForCompletion, 'completion.answers', []);

  const [, setDocsByFieldId] = useState<
    Record<string, Record<string, Documentation>>
  >({});

  const registerFieldDocs = useCallback(
    (fieldId: string, docs: Record<string, Documentation>) => {
      setDocsByFieldId((prev) => ({ ...prev, [fieldId]: docs }));
    },
    [],
  );

  // View mode is read-only — mark-as-read is never triggered because
  // `disabled` passed to `useFields` hides the affordance in FileViewerModal.
  const noopMarkAsRead = useCallback(() => {
    // no-op
  }, []);
  const emptyReadRecords: Record<string, DocumentReadRecord> = {};

  const { formFields } = useFields(
    [...questions],
    [],
    true,
    {
      readRecords: emptyReadRecords,
      onMarkAsRead: noopMarkAsRead,
      registerFieldDocs,
    },
    isViewLocked,
  );
  const defaultValues = getValues(answers);

  const taskGroupKey = _get(taskDataForCompletion, 'groupKey') as
    string | undefined;
  const formTemplateId = _get(taskDataForCompletion, 'formTemplate.id') as
    string | undefined;

  return (
    <TaskCompletionForm
      defaultValues={defaultValues}
      disableAwayConfirmation
      error={taskCompletionError}
      fields={formFields}
      formRef={formRef}
      formTemplateId={formTemplateId}
      id={id}
      isViewLocked={isViewLocked}
      loading={taskCompletionLoading}
      taskCompletionError={taskCompletionError}
      taskGroupKey={taskGroupKey}
    />
  );
}

export default TaskCompletionViewContainer;
